import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setShippingRate } from "../lib/draft.lib";

export function useSetShippingRate(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return (shippingRateId: string, title?: string | null, amount?: number | null) => {
    setDraft((draft) => (draft ? setShippingRate(draft, shippingRateId, title, amount) : draft));
  };
}
